import React, { ChangeEvent, ClipboardEvent } from 'react';

interface PasteImportFormProps {
  pasteInput: string;
  setPasteInput: (value: string) => void;
  pasteError: string;
  handlePaste: (e: ClipboardEvent<HTMLTextAreaElement>) => void;
  handleDirectPaste: () => void;
  onClose: () => void;
}

const PasteImportForm: React.FC<PasteImportFormProps> = ({
  pasteInput,
  setPasteInput,
  pasteError,
  handlePaste,
  handleDirectPaste,
  onClose
}) => {
  return (
    <div>
      <div className="mb-4">
        <label className="block text-sm mb-1">Paste Idol Item Text:</label>
        <textarea 
          value={pasteInput} 
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setPasteInput(e.target.value)}
          onPaste={handlePaste}
          className="w-full p-2 h-60 rounded bg-gray-700 text-white font-mono text-sm"
          placeholder="Paste your idol item text here..."
        />
      </div>
      
      {pasteError && (
        <div className="bg-red-900 p-3 rounded mb-4 text-sm">
          {pasteError}
        </div>
      )}
      
      <div className="flex justify-end">
        <button 
          type="button" 
          className="bg-red-600 hover:bg-red-500 px-4 py-2 rounded text-white mr-2"
          onClick={onClose}
        >
          Cancel
        </button>
        <button 
          type="button"
          onClick={handleDirectPaste}
          className="bg-blue-600 hover:bg-blue-500 px-4 py-2 rounded text-white"
        >
          Import Idol
        </button>
      </div>
      
      <div className="text-sm text-gray-400 mt-2">
        <p>Tip: You can press Ctrl+V to paste directly from your clipboard.</p>
      </div>
    </div>
  );
};

export default PasteImportForm;